import { render, staticRenderFns } from "./CrInstagramRtmpDestination.vue?vue&type=template&id=8906a2da&scoped=true&"
import script from "./CrInstagramRtmpDestination.vue?vue&type=script&lang=js&"
export * from "./CrInstagramRtmpDestination.vue?vue&type=script&lang=js&"
import style0 from "./CrInstagramRtmpDestination.vue?vue&type=style&index=0&id=8906a2da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8906a2da",
  null
  
)

export default component.exports